export default __webpack_public_path__ + "static/media/NH03.d35d4dfc.jpg";